import _ from 'lodash'
import { Input } from '../input'
import Portrait from '../portrait'
import Scrollbar from '../scrollbar'

export default {
  name: 'KChat',
  props: {
    users: {
      type: Array,
      default() {
        return [
          {
            name: 'erry.li',
            userId: 1,
            avatar: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2440771326,3484853654&fm=26&gp=0.jpg',
            lastMessage: '你是傻了吧你',
            lastMessageTime: 1536681600000,
          },
          {
            name: 'travis.lee',
            userId: 2,
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1228334647,1848602358&fm=26&gp=0.jpg',
            lastMessage: 'where would you go tomorrow',
            lastMessageTime: 1552320000000,
          },
          {
            name: '李伟',
            userId: 3,
            avatar: 'https://doterlin.github.io/vue-wxChat/src/assets/wyz.jpg',
            lastMessage: '这是我新换的头像...',
            lastMessageTime: 1556395635292,
          },
          {
            name: 'erry.li',
            userId: 4,
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1261916816,3208496505&fm=26&gp=0.jpg',
            lastMessage: '你是傻了吧你',
            lastMessageTime: 1536681600000,
          },
          {
            name: 'travis.lee',
            userId: 5,
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1228334647,1848602358&fm=26&gp=0.jpg',
            lastMessage: 'where would you go tomorrow',
            lastMessageTime: 1552320000000,
          },
          {
            name: '李伟',
            userId: 6,
            avatar: 'https://doterlin.github.io/vue-wxChat/src/assets/wyz.jpg',
            lastMessage: '这是我新换的头像...',
            lastMessageTime: 1556395635292,
          },
          {
            name: 'erry.li',
            userId: 7,
            avatar: 'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=254309635,3352311220&fm=26&gp=0.jpg',
            lastMessage: '你是傻了吧你',
            lastMessageTime: 1536681600000,
          },
          {
            name: 'travis.lee',
            userId: 8,
            avatar: 'https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=1718212204,2309151559&fm=58',
            lastMessage: 'where would you go tomorrow',
            lastMessageTime: 1552320000000,
          },
          {
            name: '李伟',
            userId: 9,
            avatar: 'https://doterlin.github.io/vue-wxChat/src/assets/wyz.jpg',
            lastMessage: '这是我新换的头像...',
            lastMessageTime: 1556395635292,
          },
        ]
      },
    },
  },
  data() {
    return {
      activeId: null,
    }
  },
  computed: {},
  watch: {},
  render() {
    const css = { 'km-chat': true }
    const props = {}
    const events = {}
    const data = {
      class: css,
      props,
      on: events,
    }
    return <div {...data}>
      <div class="km-chat__side">
        <div class="km-chat__search">
          <Input
            rounded={true}
            spellCheck={false}
            prefix='search-s' />
        </div>
        <Scrollbar wrapClass={'km-chat__scroll-wrap'}>
          <ul class="km-chat__users">
            {
              _.map(this.users, user => {
                return (
                  <li class={{
                    'user-panel': true,
                    'is-active': user.userId === this.activeId,
                  }} onClick={() => {
                    this.handleUserClick(user)
                  }}>
                    {this.$scopedSlots.user
                      ? this.$scopedSlots.user(user)
                      : [<Portrait
                        class="user-portrait"
                        url={user.avatar}
                        width={45}
                        height={45}
                        rounded={true} />, <div
                        class="user-detail">
                        <div class="user-name">{user.name}</div>
                        <div class="user-message">{user.lastMessage}</div>
                      </div>,
                      ]
                    }
                  </li>
                )
              })
            }
          </ul>
        </Scrollbar>
      </div>
      <div clas="km-chat__main">
        <div class="km-chat-history__wrapper"></div>
        <div class="km-chat-input__wrapper"></div>
      </div>
    </div>
  },
  methods: {
    handleUserClick(user) {
      // console.log(user)
      this.activeId = user.userId
    },
  },
}
